import * as Turbo from "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";
import * as tabler from "@tabler/core";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;
window.Bootstrap = tabler.bootstrap;

const controllers = import.meta.glob("./**/*_controller.js", { eager: true });
registerControllers(application, controllers);

Turbo.start();
